import styled from 'styled-components';

export const Content = styled.div`
  float: left;
  width: 100%;
  padding: 20px;

  @media (max-width: 1024px) {
    overflow-x: hidden;
  }
`;

export const LoadArea = styled.div`
  float: left;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const Cards = styled.div`
  float: left;
  width: 100%;
  padding: 0 10px;
  margin-bottom: 20px;

  main {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0px;
    float: left;
    width: 100%;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    width: 100%;
    padding: 15px;
    margin-bottom: 0px;

    main {
      flex-direction: column;
      width: 100%;
    }
  }
`;

export const Card = styled.div`
  float: left;
  width: 25%;
  padding: 10px;

  div {
    background: ${({ theme }) => theme.colors.LIGHT1};
    border-radius: 8px;
    border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
    padding: 30px 20px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    float: left;
    width: 100%;
    height: 100%;

    main {
      display: flex;
      flex-direction: column;
      float: left;
      width: 100%;

      h2 {
        color: ${({ theme }) => theme.colors.TEXT4};
        font-size: 14px;
        margin: 0 0 5px 0;
      }

      h1 {
        color: ${({ theme }) => theme.colors.TEXT1};
        font-size: 26px;
      }

      p {
        width: 100%;
        float: left;
        display: flex;
        flex-direction: column;
        margin: 10px 0 0 0;

        h3 {
          color: ${({ theme }) => theme.colors.TEXT4};
          font-size: 12px;
          margin: 5px 0 0 0;
        }

        h4 {
          color: ${({ theme }) => theme.colors.TEXT1};
          font-size: 12px;
        }
      }

      span {
        margin: 20px 0 0 0;
        width: 100%;
        float: left;
        height: 15px;
        border-radius: 5px;
        background: ${({ theme }) => theme.colors.LIGHT1};
        overflow: hidden;
      }

      ins {
        float: left;
        height: 15px;
        background: ${({ theme }) => theme.colors.ORANGE};
        opacity: 0.8;
      }

      small {
        font-size: 10px;
        color: ${({ theme }) => theme.colors.TEXT4};
        margin: 3px 0 0 0;
      }
    }
  }

  &.up i {
    transform: rotate(45deg);
  }

  &.down i {
    transform: rotate(-45deg);
  }

  &:nth-child(odd) {
    div {
      background: ${({ theme }) => theme.colors.LIGHT1};
    }
  }

  i {
    display: flex;
    align-self: flex-start;
  }

  i span {
    color: ${({ theme }) => theme.colors.ORANGE};
    text-decoration: none;
    font-style: normal;
    font-size: 16px;
    font-weight: 700;
    font-family: Arial, Helvetica, sans-serif;
    border: ${({ theme }) => `1px solid ${theme.colors.ORANGE}`};
    width: 28px;
    height: 28px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 1024px) {
    width: 100%;
    padding: 0px;
    margin: 0 0px 15px 0;
    
    &:last-child {
      margin-bottom: 0px;
    }

    div {
      padding: 20px 10px;
      justify-content: flex-start;
      align-items: flex-start;
      border-radius: 10px;

      i {
        margin-left: 40px;
      }

      main {
        h1 {
          font-size: 16px;
          font-weight: 700;
          text-align: left;
        }

        h2 {
          font-size: 14px;
          font-weight: 700;
          text-align: left;
        }

        p {
          h3 {
            font-size: 12px;
            font-weight: 700;
            text-align: left;
          }

          h4 {
            font-size: 12px;
            font-weight: 700;
            text-align: left;
          }
        }
      }
    }
  }
`;

export const Boards = styled.div`
  float: left;
  width: 100%;
  padding: 20px;

  @media (max-width: 1024px) {
    padding: 15px 0 30px 0;
  }
`;

export const Board = styled.div`
  float: left;
  width: 100%;
  background: ${({ theme }) => theme.colors.LIGHT1};
  border-radius: 8px;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  padding: 0px;
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0px;
  }

  header {
    width: 100%;
    float: left;
    padding: 20px;
    margin: 0 0 0px 0;
    align-items: center;
    display: flex;
    font-size: row;
    justify-content: space-between;

    h1 {
      display: flex;
      align-items: center;

      i {
        margin-right: 10px;
      }

      div {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        span {
          color: ${({ theme }) => theme.colors.TEXT1};
          font-size: 20px;
        }

        small {
          background: rgb(19, 226, 123, 0.4);
          font-weight: 700;
          color: ${({ theme }) => theme.colors.TEXT1};
          font-size: 10px;
          border-radius: 5px;
          padding: 3px 5px;
        }
      }
    }

    button {
      background: none;
      cursor: pointer;
      transition: all 0.5s ease;

      &:hover {
        opacity: 0.7;
        transform: rotate(-180deg);
      }
    }
  }

  main {
    float: left;
    width: 100%;
  }

  @media (max-width: 1024px) {
    padding: 0px;

    border-radius: 6px;
    border-width: 0px;
    border-top-width: 1px;
    border-bottom-width: 1px;
    margin: 0 0 30px 0;

    header {
      padding: 15px 10px;
      margin: 0px;

      h1 {
        div {
          span {
            font-size: 12px;
          }

          small {
            font-size: 8px;
          }
        }
      }
    }
  }
`;

export const CountItem = styled.div`
  float: left;
  width: 40px;
  height: 40px;
  background: ${({ theme }) => theme.colors.LIGHT1};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  border-radius: 100%;

  @media (max-width: 1024px) {
    font-size: 12px;
    width: 26px;
    height: 26px;
  }
`;

export const ProgressTag = styled.div`
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  border-radius: 5px;
  padding: 3px;
  color: ${({ theme }) => theme.colors.TEXT1};
  background-color: ${({ theme }) => theme.colors.GREENDARK};
  margin: 5px 0 0 0;

  @media (max-width: 1024px) {
    font-size: 10px;
    padding: 0px;
    width: auto;
  }
`;
